import { toast } from 'react-toastify';

// Meldingen, onder water react-toastify.
//
// De aanroepen droegen lang een titel mee — een overblijfsel van react-notifications,
// dat er een kop boven de melding van maakte. Toastify kent die kop niet, dus die titel
// verdween al jaren in het niets; op eenentwintig plekken stond er zelfs 'error' in
// plaats van 'Fout' zonder dat iemand dat ooit kon zien. Nu is hij weg uit de handtekening,
// zodat niemand hem opnieuw invult in de veronderstelling dat het iets doet.
const build = (type) => (message, timeout) =>
  toast[type](message, timeout ? { autoClose: timeout } : undefined);

export const NotificationManager = {
  success: build('success'),
  error: build('error'),
  warning: build('warning'),
  info: build('info'),
};
